import axios from '@/libs/api.request'

export const getMechanicalPart = (id) => {
  return axios.request({
    url: `parts/mechanical-part/${id}`,
    method: 'get'
  })
}

export const createMechanicalPart = (data) => {
  return axios.request({
    url: 'parts/mechanical-part/create',
    method: 'post',
    data
  })
}

export const updateMechanicalPart = (id, data) => {
  return axios.request({
    url: `parts/mechanical-part/${id}`,
    method: 'put',
    data
  })
}

export const getChangeLogs = (id) => {
  return axios.request({
    url: `parts/mechanical-part/${id}/changes`,
    method: 'get'
  })
}

export const getMechanicalPartSpec = (id) => {
  return axios.request({
    url: `parts/mechanical-part/${id}/specs`,
    method: 'get'
  })
}

export const updateMechanicalPartSpec = (id, data) => {
  return axios.request({
    url: `parts/mechanical-part/${id}/specs`,
    method: 'post',
    data
  })
}
